export const REGEXP_ADD_SEPARATORS = /\B(?=(\d{3})+(?!\d))/g
export const REGEXP_URL_PATH = /^.*?:\/\/[^/]+/
export const REGEXP_TRAILING_SLASH = /\/$/
export const REGEXP_GET_SOCIAL_FROM_URL = /.*\//
export const REGEXP_GET_URL_WITHOUT_LANGUAGE = /^(\/[^/]+)?(\/[^?#]*)/
export const REGEXP_LANGUAGE = /^\/[a-z]{2}(?:-[A-Z]{2})?\//
export const REGEXP_QUERY_PARAMS = /\?(.*)/
export const TRAILING_SLASH = /\/$/
export const REGEXP_ONLY_NUMBERS = /^[1-9]\d*$/
export const REGEXP_CURRENCY_SYMBOL = /[^0-9.,]+/
export const REGEXP_FILE_EXTENSION = /\.(txt|pdf|docx|jpg|png|svg|json)$/i
export const REGEXP_TYPE_IMAGE = /\.(jpg|jpeg|png|gif|bmp|tiff|webp)$/i
export const REGEXP_QUERIES = /^(https?:\/\/)/i
export const REGEXP_VIDEOS = /\.(mp4|mov|avi|wmv|flv)$/i
export const REGEXP_REMOVE_BRACKETS = /\[\d*\]| \[\]/g
export const REGEXP_CONTENT_DISPOSITION = /filename\s*=\s*["']?([^"']*)["']?/
export const REGEXP_SPLIT_WORDS = /("[^"]+"|\S+)/g
export const REGEXP_REMOVE_QUOTES = /['"]/g
export const REGEXP_REMOVE_SPACES = /\s/g
export const REMOVE_WORD_NOT = /\bnot\b/g
export const REMOVE_WORD_AND = /\bnot\b/g
export const REMOVE_WORD_OR = /\bor\b/g
export const REGEXP_SPLIT_INPUT_FILTER =
  /[^"]+?(?=\band\b|\bor\b|\bnot\b|$)|"[^"]*"|\b(?:and|or|not)\b[^"]*?(?=\band\b|\bor\b|\bnot\b|$)/g
export const REGEXP_DATE_FORMAT = /^[0-9. -]*$/
export const REGEXP_NUMBERS = /[^\d.]/g
